import {
  PRIVACY_POLICY_ROUTE,
  TERMS_AND_CONDITONS_ROUTE,
} from "@/lib/constants/routes";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import VisaMastercard from "../../assets/images/VisaMastercard.png";
import { ContactsPopover } from "./ContactsPopover";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="flex flex-col-reverse w-full items-center justify-center relative">
      <div className="flex space-x-[24px] w-full items-center justify-center p-[30px]">
        <div>
          <ContactsPopover />
        </div>
        <div>
          <Link
            to="/"
            className="text-[#00000080] font-medium leading-[17px] text-[17px] hover:text-[#001D98]"
          >
            {t("footer.knowledge_base")}
          </Link>
        </div>
        <div>
          <Link
            to={PRIVACY_POLICY_ROUTE}
            className="text-[#00000080] font-medium leading-[17px] text-[17px] hover:text-[#001D98]"
          >
            {t("footer.privacy_policy")}
          </Link>
        </div>
        <div>
          <Link
            to={TERMS_AND_CONDITONS_ROUTE}
            className="text-[#00000080] font-medium leading-[17px] text-[17px] hover:text-[#001D98]"
          >
            {t("footer.terms_and_conditions")}
          </Link>
        </div>
      </div>

      <div className="absolute ml-auto max-w-[250px] select-none bottom-[10px] right-0">
        <img src={VisaMastercard} alt="Visa and Mastercard" />
      </div>
    </footer>
  );
};

export default Footer;
